module.exports = __webpack_public_path__ + "img/78dcf75.png";